export enum AdminBoxStatus {
  Draft = 'DRAFT',
  Private = 'PRIVATE',
  Protected = 'PROTECTED',
  Public = 'PUBLIC',
}
